import React, { useState, useEffect } from 'react';
import { Button, Typography, Slider, Divider } from 'antd';
import PropTypes from 'prop-types';
import { RedoOutlined } from '@ant-design/icons';
import 'leaflet/dist/leaflet.css';

const { Text } = Typography;

// A reusable slider component for adjusting numerical scale values with a title and reset capability.
const ScaleSlider = ({ title, value, onChange, min, max, step, precision = 0 }) => {
  const [tempValue, setTempValue] = useState(value);

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  const handleSliderChange = (newValue) => {
    if (typeof newValue === 'number') {
       setTempValue(newValue);
    }
  };

  const handleAfterChange = (finalValue) => {
     if (typeof finalValue === 'number') {
        onChange(finalValue);
     } else {
        onChange(tempValue);
     }
  };

  const displayValue = typeof tempValue === 'number' ? tempValue : min;

  return (
      <div style={{ marginBottom: '15px', padding: '0 8px' }}>
          <Text style={{ color: '#EEEEEE' }}>{`${title}: ${displayValue.toFixed(precision)}`}</Text>
          <Slider
              min={min}
              max={max}
              step={step}
              value={displayValue}
              onChange={handleSliderChange}
              onAfterChange={handleAfterChange}
              trackStyle={{ backgroundColor: '#76ABAE' }}
              handleStyle={{ borderColor: '#76ABAE' }}
              tooltip={{ formatter: (value) => value?.toFixed(precision) }}
          />
      </div>
  );
};

ScaleSlider.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    step: PropTypes.number.isRequired,
    precision: PropTypes.number,
};

// A component that provides UI controls for adjusting various map-related icon scaling settings.
const MapSettings = ({
  mapIconScale, setMapIconScale, legendScale, setLegendScale, moduleIconScale, setModuleIconScale,
}) => {

  // Resets all icon scale settings to their default values.
  const resetIconScales = () => {
    const defaultScale = 32;
    setLegendScale(defaultScale);
    setMapIconScale(defaultScale);
    setModuleIconScale(defaultScale);
  };

  return (
    <>
      <Divider orientation="left" plain style={{ borderColor: '#555', color: '#aaa' }}>
        Icon Scaling
      </Divider>
      <ScaleSlider title="Map Icon Scale" value={mapIconScale} onChange={setMapIconScale} min={16} max={100} step={1} precision={0}/>
      <ScaleSlider title="Module Name Scale" value={moduleIconScale} onChange={setModuleIconScale} min={16} max={100} step={1} precision={0}/>
      <ScaleSlider title="Legend Icon Scale" value={legendScale} onChange={setLegendScale} min={16} max={100} step={1} precision={0}/>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px', paddingRight: '8px' }}>
        <Button
          icon={<RedoOutlined style={{ color: '#76ABAE' }} />}
          onClick={resetIconScales}
          title="Reset Icon Scales to Default (32)"
          size="small"
        />
      </div>
    </>
  );
};

MapSettings.propTypes = {
  mapIconScale: PropTypes.number.isRequired, setMapIconScale: PropTypes.func.isRequired,
  legendScale: PropTypes.number.isRequired, setLegendScale: PropTypes.func.isRequired,
  moduleIconScale: PropTypes.number.isRequired, setModuleIconScale: PropTypes.func.isRequired,
};

export default MapSettings;